import { ImageCarouselEvent } from '@naturehouse/design-system/components/organisms/image-carousel/ImageCarousel';
import GTMOverviewImageNavigationModel from '../../gtm/models/GTMOverviewImageNavigationModel';
import GTM from '../../gtm/GTM';

export default class ImageCarouselTrackingManager {
    static #instance: ImageCarouselTrackingManager | null = null;

    public static getInstance(
        imageCarousel: HTMLElement,
        houseId: string
    ): ImageCarouselTrackingManager {
        if (this.#instance === null || this.#instance.houseId !== houseId) {
            this.#instance = new ImageCarouselTrackingManager(imageCarousel, houseId);
        }

        return this.#instance;
    }

    public static destroyInstance(houseId: string): void {
        if (this.#instance === null || this.#instance.houseId !== houseId) {
            return;
        }

        this.#instance = null;
    }

    private constructor(
        private readonly imageCarousel: HTMLElement,
        private readonly houseId: string
    ) {
        this.#setEventListeners();
    }

    readonly #setEventListeners = (): void => {
        this.imageCarousel.addEventListener(
            ImageCarouselEvent.NEXT_BUTTON_CLICK,
            this.#trackNextButtonEvent
        );

        this.imageCarousel.addEventListener(
            ImageCarouselEvent.PREV_BUTTON_CLICK,
            this.#trackPrevButtonEvent
        );
    };

    readonly #trackNextButtonEvent = (): void => {
        GTM.track(
            GTMOverviewImageNavigationModel.parseToGTMData({
                direction: 'next'
            })
        );

        this.imageCarousel.removeEventListener(
            ImageCarouselEvent.NEXT_BUTTON_CLICK,
            this.#trackNextButtonEvent
        );
    };

    readonly #trackPrevButtonEvent = (): void => {
        GTM.track(
            GTMOverviewImageNavigationModel.parseToGTMData({
                direction: 'prev'
            })
        );

        this.imageCarousel.removeEventListener(
            ImageCarouselEvent.PREV_BUTTON_CLICK,
            this.#trackPrevButtonEvent
        );
    };
}
